// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"333":"0fc98e17","640":"f925e882"}[chunkId] + ".js";
};